import { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';

export function Timer({ initial = 600, onFinish = () => {} }) {
    const [remaining, setRemaining] = useState(initial);
    useEffect(() => {
        if (remaining <= 0) {
            onFinish?.();
            return;
        }

        const timerId = setInterval(() => {
            setRemaining((prev) => {
                if (prev <= 1) {
                    clearInterval(timerId);
                    return 0;
                }
                return prev - 1;
            })
        }, 1000);

        return () => clearInterval(timerId);
    })
    return <div>
        <Alert variant={remaining > initial/2 ? "info" : "danger"}>
        ⏱ Time Remaining: {Math.floor(remaining / 60)}:{String(remaining % 60).padStart(2, '0')}
        </Alert>
    </div>
}